const MAX_SSE_BUFFER_CHARS = 256 * 1024;

export const parseSseBlock = (block) => {
    if (typeof block !== 'string' || !block.trim()) {
        return null;
    }
    let event = 'message';
    let id = null;
    const dataLines = [];
    block.split(/\r?\n/).forEach((line) => {
        if (line.startsWith(':')) {
            return;
        }
        if (line.startsWith('event:')) {
            event = line.slice(6).trim() || 'message';
        } else if (line.startsWith('id:')) {
            id = line.slice(3).trim() || null;
        } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).replace(/^ /, ''));
        }
    });
    if (!dataLines.length) {
        return null;
    }
    try {
        return { event, id, data: JSON.parse(dataLines.join('\n')) };
    } catch (error) {
        return null;
    }
};

export const consumeSseResponse = async (response, onFrame) => {
    if (!response?.body?.getReader) {
        throw new Error('The event stream response is unavailable.');
    }
    const reader = response.body.getReader();
    const decoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder();
    let buffer = '';

    const decode = (value, stream) => {
        if (decoder) {
            return decoder.decode(value, { stream });
        }
        return Array.from(value || [], (byte) => String.fromCharCode(byte)).join('');
    };

    const consumeBlocks = async (source, final = false) => {
        buffer += source;
        if (buffer.length > MAX_SSE_BUFFER_CHARS) {
            throw new Error('The event stream response exceeded its safety bound.');
        }
        const parts = buffer.split(/\r\n\r\n|\n\n|\r\r/);
        buffer = final ? '' : parts.pop() || '';
        for (const part of parts) {
            const frame = parseSseBlock(part);
            if (frame) {
                await onFrame(frame);
            }
        }
        if (final && buffer.trim()) {
            const frame = parseSseBlock(buffer);
            if (frame) {
                await onFrame(frame);
            }
        }
    };

    let done = false;
    while (!done) {
        const chunk = await reader.read();
        done = chunk.done;
        await consumeBlocks(decode(chunk.value || new Uint8Array(), !done), done);
    }
};
